const giphyArtists = [
    "Grande+Dame",
    "Dylan+Morang",
    "Toke",
    "Pusheen",
    "TRIPPIESTEFF",
];

export default giphyArtists;